import React from 'react'
import PropTypes from 'prop-types'

import ProjectBudgetListItem from "./ProjectBudgetListItem";

const ProjectBudgetList = ({project_id, budgets, addresses}) => {

    return (
        <div className="d-flex flex-column">
            {
                budgets.map((budget, index) => <ProjectBudgetListItem
                    key={index}
                    project_id={project_id}
                    addresses={addresses}
                    {...budget}
                />)
            }
        </div>
    )

}

ProjectBudgetList.propTypes = {
    project_id: PropTypes.string.isRequired,
    budgets: PropTypes.array,
    addresses: PropTypes.array,
}

export default ProjectBudgetList